APP.init = function () {
	APP.device()
	APP.header()
	APP.modal()
	APP.search()
	APP.footer()
}
